import PeriodSelector from "components/PeriodSelector";
import ToolbarTitle from "design/components/texts/ToolbarTitle";
import ToolbarContainer from "design/components/toolbar/ToolbarContainer";
import Right from "design/layouts/Right";
import SplitView from "design/layouts/SplitView";
import { getFileApiURL } from "qpr-base/utils/url-utils";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import { t } from "i18next";

const useIconStyles = makeThemedStyles(
  "ExecutiveDashboardToolbarIcon",
  (theme) => ({
    root: {
      marginLeft: 0,
      marginRight: "15px",
      marginTop: 0,
      width: "50px",
      height: "50px",
      backgroundImage: `url(${getFileApiURL(`/icons/navitems/executive.svg`)})`,
    },
  })
);

const ExecutiveDashboardToolbar = () => {
  const iconstyles = useIconStyles();
  return (
    <ToolbarContainer>
      <SplitView partCnt={2}>
        <ToolbarTitle>
          <span className={iconstyles.root}></span>
          {t("toolbar.Corporate Dashboard")}
        </ToolbarTitle>
        <Right>
          <PeriodSelector />
        </Right>
      </SplitView>
    </ToolbarContainer>
  );
};

export default ExecutiveDashboardToolbar;
